var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerConstructionDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14H16V17H20V33C20 33.3333 20.2 34 21 34C21.8 34 22 33.3333 22 33V17H26V16C26 14.4 24.6667 14 24 14Z",
    fill: "#FAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 14H29L28 18L29 20V25L28 27V32C28 32.6667 28.4 34 30 34C31.6 34 32 32.6667 32 32V27L31 25V20L32 18L31 14Z",
    fill: "#FAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerConstructionDisabled);
export default __webpack_public_path__ + "static/media/marker_construction_disabled.723fc567827d35ca9293af1ad2c5739e.svg";
export { ForwardRef as ReactComponent };